module.exports = __webpack_public_path__ + "static/4d49f62110830c1f4599805254d0b1a4f2164bc313de956ba1eba453d6178f61-b3ddce5e208fffb7605c0b6dafacf7c4.png";